const MAP = {
  pending: { label: "Pending", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  scheduled: { label: "Scheduled", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  queued: { label: "Queued", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  running: { label: "Running", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  paused: { label: "Paused", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  completed: { label: "Completed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  failed: { label: "Failed", cls: "bg-red-50 text-red-700 border-red-200" },
  done: { label: "Done", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export default function StatusBadge({ status }) {
  const s = MAP[status] || MAP.pending;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${s.cls}`}
    >
      {(status === "running" || status === "queued") && <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-current" />}
      {s.label}
    </span>
  );
}
